import Alpine from 'alpinejs';
import '../css/app.css';

window.Alpine = Alpine;
Alpine.start();

// Vendor
import './vendor/prism.js';
import './vendor/aos.js';

// Components
import './components/fanuc-product-renaming';

